import React from "react";
import Navbar from "../components/navbar";
import Hero from "../components/hero";
import Footer from "../components/footer";
import "../styles/universal.css";
import "../styles/contactPage.css";

const ContactPage = () => {
  return (
    <div className="contact-page">
      <Navbar />
      <Hero
        title="Contact Me"
        subtitle="Get in touch to schedule a session or ask any questions you may have."
      />

      <div className="contact-container">
        <div className="contact-content">
          <div className="contact-info-section">
            <div className="contact-card">
              <div className="contact-icon">
                <i className="fas fa-phone"></i>
              </div>
              <h3>Phone & WhatsApp</h3>
              <p>+27 71 496 7512</p>
            </div>

            <div className="contact-card">
              <div className="contact-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <h3>Email</h3>
              <p>erinrobinsoncounselling@gmail.com</p>
            </div>

            <div className="contact-card">
              <div className="contact-icon">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <h3>Location</h3>
              <p>
                The Space Holistic Wellness Centre
                <br />
                577 Rossouw Street
                <br />
                Die Wilgers
                <br />
                Pretoria, 0184
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="map-section-underlay">
        <div className="map-section">
          <h2>Find Me</h2>
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3591.8934523456!2d28.2789!3d-25.7831!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e9561d2aaa59c6b%3A0x2f3e8e9e8e9e8e9e!2s577%20Rossouw%20St%2C%20Die%20Wilgers%2C%20Pretoria%2C%200184!5e0!3m2!1sen!2sza!4v1234567890123!5m2!1sen!2sza"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="The Space Holistic Wellness Centre Location"
            ></iframe>
          </div>
        </div>
      </div>

      <div className="contact-container">
        <div className="contact-content">
          <blockquote className="hours-section">
            Sessions are available by appointment only. Please contact me to
            schedule your session at a time that works for you.
          </blockquote>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ContactPage;
